var _style, _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1024",
    style: {
      enableBackground: "new 0 0 1280 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:#034F75;}\r\n\t.st1{opacity:0.1;fill:url(#SVGID_1_);}\r\n\t.st2{opacity:0.1;fill:url(#SVGID_2_);}\r\n\t.st3{opacity:0.1;fill:url(#SVGID_3_);}\r\n\t.st4{opacity:0.1;fill:url(#SVGID_4_);}\r\n\t.st5{opacity:0.1;fill:url(#SVGID_5_);}\r\n\t.st6{opacity:0.1;fill:url(#SVGID_6_);}\r\n\t.st7{opacity:0.1;fill:url(#SVGID_7_);}\r\n\t.st8{opacity:0.1;fill:url(#SVGID_8_);}\r\n\t.st9{opacity:0.1;fill:url(#SVGID_9_);}\r\n\t.st10{opacity:0.1;fill:url(#SVGID_10_);}\r\n\t.st11{opacity:0.1;fill:url(#SVGID_11_);}\r\n\t.st12{opacity:0.1;fill:url(#SVGID_12_);}\r\n\t.st13{opacity:0.1;fill:url(#SVGID_13_);}\r\n\t.st14{opacity:0.1;fill:url(#SVGID_14_);}\r\n\t.st15{opacity:0.1;fill:url(#SVGID_15_);}\r\n\t.st16{opacity:0.1;fill:url(#SVGID_16_);}\r\n\t.st17{opacity:0.1;fill:url(#SVGID_17_);}\r\n\t.st18{opacity:0.1;fill:url(#SVGID_18_);}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1280,
    height: 1024
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 666.7374,
    y1: 772.5004,
    x2: 723.4471,
    y2: 870.7246,
    gradientTransform: "matrix(0.6586 -0.7525 0.7525 0.6586 -267.0194 505.3404)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 809,
    cy: 523.4,
    r: 56.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 895.7535,
    y1: 165.9423,
    x2: 1015.3005,
    y2: 373.0037
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 955.5,
    cy: 269.5,
    r: 119.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 726.8279,
    y1: 679.9481,
    x2: 752.9144,
    y2: 725.1312,
    gradientTransform: "matrix(0.6586 -0.7525 0.7525 0.6586 -267.0194 505.3404)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 748.9,
    cy: 411.3,
    r: 26.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1042.2573,
    y1: 149.1536,
    x2: 1145.3889,
    y2: 327.7827
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1093.8,
    cy: 238.5,
    r: 103.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 1072.7598,
    y1: 474.8595,
    x2: 1197.1747,
    y2: 690.3524
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 1135,
    cy: 582.6,
    r: 124.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.5863,
    y1: 640.9683,
    x2: 249.6335,
    y2: 819.4512
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 198.1,
    cy: 730.2,
    r: 103
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -128.4685,
    y1: 1134.9773,
    x2: -20.2781,
    y2: 1322.3687,
    gradientTransform: "matrix(-8.521625e-02 0.9964 -0.9964 -8.521625e-02 1342.5831 555.9669)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 124.7,
    cy: 377.2,
    r: 108.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -124.5248,
    y1: 1091.0524,
    x2: -34.9155,
    y2: 1246.2601,
    gradientTransform: "matrix(-8.521625e-02 0.9964 -0.9964 -8.521625e-02 1342.5831 555.9669)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 185,
    cy: 376.9,
    r: 89.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 315.5858,
    y1: 123.9144,
    x2: 372.2956,
    y2: 222.1386,
    gradientTransform: "matrix(0.6077 -0.7942 0.7942 0.6077 6.3371 258.7143)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 352.8,
    cy: 90.7,
    r: 56.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.8912,
    y1: 43.9086,
    x2: 307.9777,
    y2: 89.0917,
    gradientTransform: "matrix(0.6077 -0.7942 0.7942 0.6077 6.3371 258.7143)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 238.4,
    cy: 64.9,
    r: 26.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 1008.2003,
    y1: 67.8177,
    x2: 1034.2867,
    y2: 113.0008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 1021.2,
    cy: 90.4,
    r: 26.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 1192.2003,
    y1: 721.8177,
    x2: 1218.2867,
    y2: 767.0008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 1205.2,
    cy: 744.4,
    r: 26.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.2003,
    y1: 642.8177,
    x2: 392.2868,
    y2: 688.0008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 379.2,
    cy: 665.4,
    r: 26.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 1129.5756,
    y1: 633.8629,
    x2: 1178.4202,
    y2: 718.4642
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 1154,
    cy: 676.2,
    r: 48.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 403.2003,
    y1: 870.8177,
    x2: 429.2868,
    y2: 916.0008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 416.2,
    cy: 893.4,
    r: 26.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.5755,
    y1: 782.8629,
    x2: 389.4201,
    y2: 867.4642
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 365,
    cy: 825.2,
    r: 48.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 945.8248,
    y1: 901.0004,
    x2: 1003.1708,
    y2: 1000.3267
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 974.5,
    cy: 950.7,
    r: 57.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 878.2003,
    y1: 859.8177,
    x2: 904.2867,
    y2: 905.0008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 891.2,
    cy: 882.4,
    r: 26.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern03);
export default __webpack_public_path__ + "static/media/pattern03.d3483eb795eb585e599a6ae03f02d44e.svg";
export { ForwardRef as ReactComponent };